let widgetsvalues = {};
export function setLocalStorageWidgetsNotepadSize(width, height) {
  widgetsvalues = {
    ...widgetsvalues,
    dim: { width: width, height: height },
  };
  localStorage.setItem("widgetsControler", JSON.stringify(widgetsvalues));
}

export function setLocalStorageWidgetsNotepadContent(notepadValue) {
  widgetsvalues = {
    ...widgetsvalues,
    notepadContent: notepadValue,
  };
  localStorage.setItem("widgetsControler", JSON.stringify(widgetsvalues));
}

export function setLocalStorageWidgets(
  engagementHistory,
  clientInformation,
  quickReplies,
  scripts,
  messageWindowExpanded,
  widgetExpanded,
  customWidgets,
) {
  widgetsvalues = {
    ...widgetsvalues,
    widgetsVisibility: {
      engagementHistory: engagementHistory,
      clientInformation: clientInformation,
      quickReplies: quickReplies,
      scripts: scripts,
      messageWindowExpanded: messageWindowExpanded,
      widgetExpanded: widgetExpanded,
      customWidgets: customWidgets,
    },
  };
  localStorage.setItem("widgetsControler", JSON.stringify(widgetsvalues));
}